import { stripeSuccessModalOpenAtom } from '@/atoms/stripeSuccessModalAtom';
import { cn } from '@/lib/cn';
import { Button } from '@heidi/design-system/button';
import { FramedIcon } from '@heidi/design-system/framed-icon';
import { Link } from '@heidi/design-system/link';
import {
  DialogDrawer,
  DialogDrawerContent,
} from '@heidi/design-system/mobile-responsive-dialog-drawer';
import {
  TypographyCaption,
  TypographyH2,
  TypographyP2,
  TypographyP2Bold,
} from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { useAtom } from 'jotai';
import {
  ExternalLinkIcon,
  Gauge,
  NotebookPen,
  PlugZap,
  Sparkles,
  Users2,
} from 'lucide-react';

export const HeidiProUpgradedSuccessful = () => {
  const [stripeSuccessModalOpen, setStripeSuccessModalOpen] = useAtom(
    stripeSuccessModalOpenAtom
  );
  const { t } = useTranslations();

  const handleStartUsingPro = () => {
    setStripeSuccessModalOpen(false);
  };

  return (
    <DialogDrawer open={stripeSuccessModalOpen} onOpenChange={setStripeSuccessModalOpen}>
      <DialogDrawerContent
        className={cn(
          'flex flex-col gap-8 p-4 sm:p-8',
          'h-[90dvh] sm:h-fit',
          'max-h-fit',
          'w-full sm:w-[500px]'
        )}
        hideCloseIcon
      >
        <div className="flex flex-col items-center gap-4 text-center">
          <FramedIcon state="pro" />
          <TypographyH2>{t('heidiProUpgradedSuccessfulModal.title')}</TypographyH2>
        </div>

        <div className="flex flex-col gap-3">
          <TypographyP2Bold className="text-text-secondary">
            {t('heidiProUpgradedSuccessfulModal.unlockedAccess')}
          </TypographyP2Bold>
          <ul className="space-y-2">
            <li className="flex items-center gap-3">
              <NotebookPen className="text-tier-pro-text" width={24} height={24} />
              <div>
                <TypographyP2>
                  {t('heidiProUpgradedSuccessfulModal.notesLikeYou')}
                </TypographyP2>
                <TypographyCaption className="text-text-secondary">
                  {t('heidiProUpgradedSuccessfulModal.unlimitedCustomTemplates')}
                </TypographyCaption>
              </div>
            </li>

            <li className="flex items-center gap-2">
              <Sparkles className="text-tier-pro-text" width={24} height={24} />
              <div>
                <TypographyP2>
                  {t('heidiProUpgradedSuccessfulModal.aiDrivenEdits')}
                </TypographyP2>
                <TypographyCaption className="text-text-secondary">
                  {t('heidiProUpgradedSuccessfulModal.unlimitedAskHeidi')}
                </TypographyCaption>
              </div>
            </li>

            <li className="flex items-center gap-2">
              <Users2 className="text-tier-pro-text" width={24} height={24} />
              <div>
                <TypographyP2>
                  {t('heidiProUpgradedSuccessfulModal.teamCollaboration')}
                </TypographyP2>
                <TypographyCaption className="text-text-secondary">
                  {t('heidiProUpgradedSuccessfulModal.shareWithTeam')}
                </TypographyCaption>
              </div>
            </li>

            <li className="flex items-center gap-2">
              <PlugZap className="text-tier-pro-text" width={24} height={24} />
              <div>
                <TypographyP2>
                  {t('heidiProUpgradedSuccessfulModal.seamlessWorkflow')}
                </TypographyP2>
                <TypographyCaption className="text-text-secondary">
                  {t('heidiProUpgradedSuccessfulModal.emrIntegrations')}
                </TypographyCaption>
              </div>
            </li>

            <li className="flex items-center gap-2">
              <Gauge className="text-tier-pro-text" width={24} height={24} />
              <div>
                <TypographyP2>
                  {t('heidiProUpgradedSuccessfulModal.lightSpeedProductivity')}
                </TypographyP2>
                <TypographyCaption className="text-text-secondary">
                  {t('heidiProUpgradedSuccessfulModal.priorityProcessing')}
                </TypographyCaption>
              </div>
            </li>
          </ul>
        </div>

        <div className="flex flex-col gap-4">
          <Button size="lg" onClick={handleStartUsingPro} className="w-full">
            {t('heidiProUpgradedSuccessfulModal.startUsingPro')}
          </Button>
          <Link
            href="https://www.heidihealth.com/pricing"
            target="_blank"
            size="sm"
            className="self-center"
          >
            {t('heidiProUpgradedSuccessfulModal.learnMore')}
            <ExternalLinkIcon />
          </Link>
        </div>
      </DialogDrawerContent>
    </DialogDrawer>
  );
};
